/**
 * Created by bing on 2018/3/30.
 */
module.exports = function (Vue) {
  Vue.prototype.$msg = function (content) {
    this.$root.$children[0].$refs.msg.msg(content)
  }
  Vue.prototype.$success = function (content) {
    this.$root.$children[0].$refs.msg.success(content)
  }
  Vue.prototype.$warn = function (content) {
    this.$root.$children[0].$refs.msg.warn(content)
  }
  Vue.prototype.$error = function (content) {
    this.$root.$children[0].$refs.msg.error(content)
  }
  Vue.prototype.$fnConfirm = function (content,done) {
    this.$confirm(content,'提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(_ => {
        done()
      })
      .catch(_ => {});
  }
};



// WEBPACK FOOTER //
// ./src/utils/notice.js